import { format, subDays } from "date-fns";

const getDurationPrice = (duration: number) => {
  const prices = {
    60: 7.99,
    75: 9.99,
    90: 11.99,
    105: 13.99,
    120: 15.99
  };
  return prices[duration as keyof typeof prices] || 7.99;
};

const calculateGoalkeeperShare = (payment: number) => {
  return Number((payment * 0.55).toFixed(2));
};

export type TransactionType = 'match' | 'withdrawal';

export interface Transaction {
  id: string;
  type: TransactionType;
  amount: number;
  date: string;
  match_location?: string;
  match_duration?: number;
  withdrawal_reference?: string;
}

export const generateDemoTransactions = () => {
  const locations = [
    "Camp Nou, Barcelona",
    "Complex Esportiu Municipal Olimpics Vall d'Hebron, Barcelona",
    "Centre Municipal de Futbol Trinitat Vella, Barcelona",
    "Camp de Futbol Municipal Nou Sardenya, Barcelona",
    "Complex Esportiu Municipal Clot de la Mel, Barcelona"
  ];

  const durations = [60, 75, 90, 105, 120];

  // Generate match earnings
  const matchTransactions: Transaction[] = Array.from({ length: 15 }, (_, index) => {
    const duration = durations[Math.floor(Math.random() * durations.length)];
    const matchPrice = getDurationPrice(duration);
    const goalkeeperShare = calculateGoalkeeperShare(matchPrice);

    return {
      id: crypto.randomUUID(),
      type: 'match',
      amount: goalkeeperShare,
      date: subDays(new Date(), index * 3).toISOString(),
      match_location: locations[Math.floor(Math.random() * locations.length)],
      match_duration: duration
    };
  });

  // Generate withdrawals (less frequent than matches)
  const withdrawalTransactions: Transaction[] = [
    {
      id: crypto.randomUUID(),
      type: 'withdrawal',
      amount: -35.00, // Negative amount for withdrawals
      date: subDays(new Date(), 7).toISOString(),
      withdrawal_reference: 'WD-001'
    },
    {
      id: crypto.randomUUID(),
      type: 'withdrawal',
      amount: -40.00,
      date: subDays(new Date(), 21).toISOString(),
      withdrawal_reference: 'WD-002'
    }
  ];

  // Combine and sort all transactions
  const allTransactions = [...matchTransactions, ...withdrawalTransactions]
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  return allTransactions;
};

export const generateMonthlyData = (transactions: Transaction[]) => {
  const monthlyData = transactions.reduce((acc: any[], transaction) => {
    const month = format(new Date(transaction.date), "MMM yyyy");
    const existingMonth = acc.find((item) => item.month === month);
    
    if (existingMonth) {
      existingMonth.amount += transaction.amount;
    } else {
      acc.push({ month, amount: transaction.amount });
    }
    
    return acc;
  }, []);

  return monthlyData.sort((a, b) => {
    return new Date(b.month).getTime() - new Date(a.month).getTime();
  });
};

export const calculateCurrentBalance = (transactions: Transaction[]) => {
  return transactions.reduce((total, transaction) => total + transaction.amount, 0).toFixed(2);
};